import React from 'react';
import { isContactEntityType } from '~/src/entities/project';
import { PopulatePageRoleCard } from './PopulatePageRoleCard';
import { PopulatePageOtherCard } from './PopulatePageOtherCard';
import { PopulatePageCardProps } from './types';

export const PopulatePageCard = (props: PopulatePageCardProps) =>
  isContactEntityType(props.group.entity_type) ? (
    <PopulatePageRoleCard {...props} />
  ) : (
    <PopulatePageOtherCard {...props} />
  );
